'use client'
// Easing functions
const EASING_FUNCTION_DEFAULT = 'cubic-bezier(0, 0, 0.24, 1.0)';
// Durations
const DURATION_DEFAULT = 300;

export { DURATION_DEFAULT, EASING_FUNCTION_DEFAULT };
